import {
    Component,
    Inject,
    OnInit,
    OnDestroy,
    PLATFORM_ID,
} from '@angular/core';
import { MarcheAPIService } from '../@core/api/marche-api.service';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';
import {
    ErrorWrapper,
    ResponseWrapper,
} from '../@shared/models/response-wrapper.model';
import { Content, HPData } from './home-page.data';
import { RouteExecutor } from '../@core/application-router/route.executor';
import { SeoService } from '../@core/seo.service';
import { HomePageService } from './home-page.service';
import { FooterPageService } from '../footer/footer-page.service';
import { OfferToggleService } from '../offer-toggle/offer-toggle.service';
import { AnalyticsService } from '../@core/analytics.service';
import { OfferVideoPopupComponent } from '../offer-video-popup/offer-video-popup.component';
import { MatDialog } from '@angular/material/dialog';
import SwiperCore from 'swiper/core';
import Swiper, {
    A11y,
    Navigation,
    Pagination,
    Scrollbar,
    Virtual,
    Autoplay,
    EffectCoverflow,
} from 'swiper/core';
import { endianness } from 'os';
import { MediaCDNService } from '../@core/media-cdn.service';
import { ActivatedRoute } from '@angular/router';

SwiperCore.use([
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Autoplay,
    EffectCoverflow,
]);
SwiperCore.use([Virtual]);
@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: [
        './home-page.component.scss',
        './home-page-v2/home-page-v2.component.scss',
    ],
})
export class HomePageComponent extends RouteExecutor implements OnInit {
    constructor(
        private marcheAPIService: MarcheAPIService,
        applicationRouterService: ApplicationRouterService,
        private seoService: SeoService,
        @Inject(PLATFORM_ID) private platformId: object,
        public homepageService: HomePageService,
        private footerService: FooterPageService,
        private analyticsService: AnalyticsService,
        public dialog: MatDialog,
        private OfferToggleService: OfferToggleService,
        public mediaCDN: MediaCDNService,
        private activatedRoute: ActivatedRoute
    ) {
        super(applicationRouterService);

        this.activatedRoute.queryParams.subscribe(param => {
            if (this.homepageService.getCurrentPage() !== -1) {
                this.page = this.homepageService.getCurrentPage();
                const savedScrollPos = this.homepageService.getScrollPosition(
                    this.page
                );
                if (savedScrollPos !== undefined) {
                    setTimeout(() => {
                        window.scrollTo(0, savedScrollPos);
                    });
                }
            }
        });
        this.updateSeo();
        this.processLink('/fn/internal?page=/&action=nav-update');
        this.processLink('/fn/internal?value=false&action=nav-toggle');
        this.processLink('/fn/internal?value=true&action=category-toggle');
        this.OfferToggleService.OfferToggle({ ...this.filters, page: 'hp' });

        const video = document.querySelector('video');
        video?.addEventListener('playing', () => {
            console.log('Video is no longer paused');
        });
    }

    static readonly HP_SEO_API = '/hp/seo';

    data: HPData[] = [];
    filters: { [p: string]: string | string[] } = {};
    loading = false;
    showShimmer = true;
    errors: ErrorWrapper[] = [];
    page = 0;
    nextPageLoading = true;
    noDataLeft = false;
    footerContent = '';
    isTimerStrip = false;
    isTimerStripV2 = false;
    scrollTopButton = false;
    swiperInstance: Swiper | null = null;
    posterImageCDN = '';
    webm = '';
    iosWeb = false;

    ngOnInit() {
        this.iosWeb = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (this.homepageService.getCurrentPage() !== -1) {
            this.page = this.homepageService.getCurrentPage();
        }
        if (this.page === 0) {
            this.data = [
                {
                    layoutType: '1-col-strip-banner',
                    layoutContent: {
                        banner: {
                            image: '',
                            link: '',
                            scrim: { color: '', alpha: '' },
                        },
                        button: {
                            alignment: '',
                            background: { color: '', image: '' },
                            height: '',
                            width: '',
                            title: { text: '' },
                            link: '',
                        },
                        title: { text: '' },
                        description: [],
                        slider: [],
                        meta: { background: '' },
                        alignment: '',
                        endsIn: '',
                    },
                },
                {
                    layoutType: '1-col-banner',
                    layoutContent: {
                        banner: {
                            image: '',
                            link: '',
                            scrim: { color: '', alpha: '' },
                        },
                        button: {
                            alignment: '',
                            background: { color: '', image: '' },
                            height: '',
                            width: '',
                            title: { text: '' },
                            link: '',
                        },
                        title: { text: '' },
                        description: [],
                        slider: [],
                        meta: { background: '' },
                        alignment: '',
                        endsIn: '',
                    },
                },
                {
                    layoutType: 'slider-with-subtext',
                    layoutContent: {
                        banner: {
                            image: '',
                            link: '',
                            scrim: { color: '', alpha: '' },
                        },
                        button: {
                            alignment: '',
                            background: { color: '', image: '' },
                            height: '',
                            width: '',
                            title: { text: '' },
                            link: '',
                        },
                        title: { text: '' },
                        description: [],
                        slider: [
                            {
                                banner: { image: '', link: '' },
                                title: { text: '' },
                            },
                            {
                                banner: { image: '', link: '' },
                                title: { text: '' },
                            },
                            {
                                banner: { image: '', link: '' },
                                title: { text: '' },
                            },
                            {
                                banner: { image: '', link: '' },
                                title: { text: '' },
                            },
                        ],
                        meta: { background: '' },
                        alignment: '',
                        endsIn: '',
                    },
                },
            ];
        }
        this.updateHomePage();
        /*if (
            !!localStorage?.getItem('HP-PPUP-SHOW') &&
            !this.analyticsService.isBot(window.navigator.userAgent)
        ) {
            // @ts-ignore
            const time = +localStorage?.getItem('HP-PPUP-SHOW');
            //   console.log((new Date().getTime() - time) / (3600 * 1000), 'time');
            if ((new Date().getTime() - time) / (3600 * 1000) > 24) {
                this.getHomePagePopupData();
            }
        } else if (!this.analyticsService.isBot(window.navigator.userAgent)) {
            this.getHomePagePopupData();
        }*/

        this.footerService.updateFilter({ ...this.filters, page: 'hp' });
    }

    updateHomePage() {
        this.loading = true;

        const filter = { page: this.page };
        this.homepageService.getHomePageData(filter).subscribe(
            res => {
                if (res?.success) {
                    this.posterImageCDN = this.mediaCDN.getImageCDN();
                    this.webm = ',f-webm';
                    this.loading = false;
                    console.log(this.page, 'page');
                    if (this.page === 0) {
                        this.data = [];
                        console.log(this.data, 'homepage');
                    }
                    if (res.data.length === 0) {
                        this.nextPageLoading = false;
                        this.noDataLeft = true;
                    } else {
                        res.data.forEach((hpData: HPData) => {
                            this.data.push(hpData);
                            if (hpData.layoutType == 'timer-strip') {
                                this.startTimer(hpData.layoutContent?.endsIn);
                                this.isTimerStrip = this.isfutureDateGreter(
                                    hpData.layoutContent?.endsIn
                                );
                            }
                            if (hpData.layoutType == 'timer-strip-v2') {
                                this.startTimerV2(hpData.layoutContent?.endsIn);
                                this.isTimerStripV2 = this.isfutureDateGreter(
                                    hpData.layoutContent?.endsIn
                                );
                            }
                        });
                    }
                } else {
                    this.errors = res.errors;
                    this.loading = false;
                }
            },
            error => {},
            () => {
                this.showShimmer = false;
            }
        );
    }

    executeFunctionLink(
        id: string,
        query: { [p: string]: string | string[] },
        body?: object
    ) {
        switch (query?.action) {
            case 'pagination':
                {
                    if (this.page === 0 && this.showShimmer) {
                        this.data = [];
                    }
                    this.page++;
                    this.updateHomePage();
                }
                break;
            case 'offer-video':
                {
                    this.openDialog(query.videoId);
                }
                break;
            case 'scroll-to-top':
                {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                }
                break;
            default:
                super.executeFunctionLink(id, query);
        }
    }

    openDialog(videoId?: any): void {
        const dialogRef = this.dialog.open(OfferVideoPopupComponent, {
            maxWidth: '',
            height: '70vh',
            panelClass: 'custom-popup',
            data: {
                videoId: videoId,
            },
        });
    }

    updateSeo() {
        this.marcheAPIService
            .getRequest<ResponseWrapper<any> | null>(
                HomePageComponent.HP_SEO_API,
                this.filters
            )
            .subscribe(res => {
                if (res?.success) {
                    this.footerContent = res?.data?.footerContent;
                    this.seoService.updateMetaTitle(res?.data?.meta?.title);
                    this.seoService.updateMetaDescription(
                        res?.data?.meta?.description
                    );
                    this.seoService.updateCanonical(res?.data?.canonical);
                    this.seoService.cacheSingleUrl(
                        window.location.host + res?.data?.canonical
                    );
                    this.seoService.updateHREFLang(res?.data?.langAlternates);
                    this.seoService.updateOgImage(res?.data.ogImage);
                }
            });
    }

    loadVideo(value: any) {
        console.log(value);
    }

    getHomePagePopupData() {
        this.marcheAPIService
            .getRequest<ResponseWrapper<any>>('/hp-ppup-show', {})
            .subscribe(res => {
                if (res?.success) {
                    res?.data?.redirects.forEach((link: string) => {
                        this.processLink(link);
                    });
                }
            });
    }

    externalLinksRedirect(link: string) {
        console.log(link);
        window.open(link, '_blank');
    }
    day: number = 0;
    hours: number = 0;
    mins: number = 0;
    seconds: number = 0;
    interval: any;

    startTimer(endInDate: string): string {
        this.interval = setInterval(() => {
            var futureDate = new Date(endInDate).getTime();
            var Today = new Date().getTime();
            var distance = futureDate - Today;
            var second = distance / 1000;
            var d = Math.floor(second / (3600 * 24));
            var h = Math.floor((second % (3600 * 24)) / 3600);
            var m = Math.floor((second % 3600) / 60);
            var s = Math.floor(second % 60);
            this.hours = d * 24 + h;
            this.mins = m;
            this.seconds = s;
            if (Today < 0) {
                clearInterval(this.interval);
            }
            if (!this.isfutureDateGreter(endInDate)) {
                this.isTimerStrip = false;
            }
        }, 1000);
        return '';
    }

    startTimerV2(endInDate: string): string {
        this.interval = setInterval(() => {
            var futureDate = new Date(endInDate).getTime();
            var Today = new Date().getTime();
            var distance = futureDate - Today;
            var second = distance / 1000;
            var d = Math.floor(second / (3600 * 24));
            var h = Math.floor((second % (3600 * 24)) / 3600);
            var m = Math.floor((second % 3600) / 60);
            var s = Math.floor(second % 60);

            // Check if hours exceed 24 and adjust day accordingly
            if (h >= 24) {
                d += Math.floor(h / 24);
                h = h % 24;
            }
            this.day = d;
            this.hours = h;
            this.mins = m;
            this.seconds = s;
            if (Today < 0) {
                clearInterval(this.interval);
            }
            if (!this.isfutureDateGreter(endInDate)) {
                this.isTimerStrip = false;
            }
        }, 1000);
        return '';
    }

    isfutureDateGreter(endInDate: string) {
        var futureDate = new Date(endInDate).getTime();
        var Today = new Date().getTime();
        return futureDate > Today;
    }

    getStyles(padding: any): { [key: string]: string } | undefined {
        if (!padding) {
            return;
        }
        const styles: { [key: string]: string } = {};

        ['top', 'bottom', 'left', 'right'].forEach(side => {
            if (padding[side]) {
                const propertyPrefix = ['top', 'bottom'].includes(side)
                    ? 'margin'
                    : 'padding';
                styles[
                    `${propertyPrefix}${side
                        .charAt(0)
                        .toUpperCase()}${side.slice(1)}`
                ] = `${padding[side]}px`;
            }
        });

        return styles;
    }

    ngOnDestroy(): void {
        const currentScrollPos = window.scrollY || window.pageYOffset;
        this.homepageService.setScrollPosition(this.page, currentScrollPos);
    }
}
